import { CompanyBrand } from 'shared/components/CompanyBrand/CompanyBrand'

import { useCompanyBranding } from './useCompanyBranding'

export function AppCompanyBrand() {
  const branding = useCompanyBranding()
  return <CompanyBrand branding={branding} />
}
